import { type IsomorphicRequestData, type BreadcrumbData } from "src/types";

import { getIsomorphicRequestData } from "./isomorphicRequestData/getIsomorphicRequestData";

export interface LoaderReturn {
  data: unknown;
  breadcrumb?:
    | BreadcrumbData
    | BreadcrumbData[]
    | Promise<BreadcrumbData | BreadcrumbData[]>;
}

type PossibleLoaderReturn =
  | LoaderReturn
  | Promise<LoaderReturn | undefined>
  | void
  | undefined;

export function loaderHandler<T extends PossibleLoaderReturn>(
  cb: (args: IsomorphicRequestData) => T,
) {
  const ctx = getIsomorphicRequestData();

  return cb(ctx);
}
